export const STATUS_OK = 200
export const STATUS_NOT_FOUND = 404
export const STATUS_SERVER_ERROR = 500
export const MIN_DAYS_TO_SHOW = 6
export const MIN_MOVIES_TO_SHOW = 4
export const MOVIE_DAYS_IN_ADVANCE = 7
export const OPEN_LATE_HOUR = 19
export const AFTERPAY_TEXT = `Accepts Afterpay`
export const GIFT_CARD_TEXT = `Accepts Westfield Gift Cards`
export const GIFT_CARD_MENU_TEXT = `gift cards`
export const STORE_HOURS_DIFFER = `(store hours may differ)`
export const HOURS_DINELATE = `Shop and dine till late`
export const HOURS_BANNER_DINELATE = `shop and dine till late`
export const CENTRE_HOURS_TEXT_LATE = `Many stores operate outside the hours below. Enjoy late night dining and entertainment, convenient supermarket shopping, and more.`
export const CENTRE_HOURS_TEXT = `Major stores may operate outside the hours below, for convenient supermarket shopping, and more.`
export const SEE_MORE_HOURS_TEXT = `See all opening hours`
export const SEE_MORE_MOVIES_TEXT = `See all Movies`
export const SEE_MORE_TEXT = `See all`
export const STACKLA_PROXY = 'stackla-proxy/disable?'
export const GRAPHQL_V2_VERSION_NUMBER = 2

export const HIDE_UTILITY_BOX = ['Event']
export const ACCORDION_ORDER = [['occurrences'], ['location', 'priceInfo']]
export const AVAILABLE_CALENDARS = ['iCal']
export const DEFAULT_CALENDAR = 'iCal'

export const WHATS_ON_EVENT_SAME_DAY = 'ddd DD MMM YYYY h:mma'
export const WHATS_ON_EVENT_NEXT_DAY = 'ddd DD MMM YYYY h:mma'
export const WHATS_ON_EVENT_NEXT_WEEK = 'ddd DD MMM YYYY h:mma'
export const WHATS_ON_EVENT_SAME_ELSE = 'ddd DD MMM YYYY h:mma'
export const DISCOVER = 'Discover'

// OPENGRAPH META FALLBACK VALUES
export const META_FALLBACK_IMAGE = `https://res.cloudinary.com/scentre-group-au/image/upload/v1523242874/westfield-logo.inline_xhroop.svg`
export const META_FALLBACK_DESCRIPTION = `No description provided.`

export const VIEW_OPTION_MEMBERS_ONLY = 'Members only'
export const WESTFIELD_PLUS_URL = '/westfield-plus'

export const CHINA_WESTFIELD_URLS = [
  'china.westfield.co.nz',
  'china.westfield.com.au',
]

export const trustedHostnameSuffixes = [
  'scentregroup.com',
  'scentregroup.io',
  'scentregroup.cloud',
  'westfield.com.au',
  'westfield.co.nz',
  'westfieldgiftcards.com.au',
]

export const trackingActions = {
  viewPromotion: 'ga.event.viewPromotion',
}

export const trackingTypes = {
  promotion: 'data-promotion',
}

export const trackingNullValue = '/gtm/null'

export enum RawCookieName {
  DGC_CART_ID = '_sg_dgc_cartId',
  DGC_CART_PREVIOUS_ID = '_sg_dgc_cartPreviousId',
  DGC_CART_COUNT = '_sg_dgc_cartCount',
  CART_ID = '_sg_cartId',
  CART_PREVIOUS_ID = '_sg_cartPreviousId',
  CART_COUNT = '_sg_cartCount',
  SUBURB = '_sg_suburb',
  CENTRE = '_sg_centre',
  ITEMS_PER_PAGE = '_sg_itemsPerPage',
  CREDIT_CARD_CHECKBOX = 'creditCardCheckbox',
  DELIVERY_ADDRESS_CHECKBOX = 'deliveryAddressCheckbox',
  ACCESS_TOKEN = 'accessToken',
  ID_TOKEN = 'idToken',
  EXPIRES_AT = 'expiresAt',
}

export const REVALIDATION_PERIODS = {
  static: 1 * 60, // eslint-disable-line no-magic-numbers
  dynamic: 1 * 60, // eslint-disable-line no-magic-numbers
  notFound: 1 * 60, // eslint-disable-line no-magic-numbers
}
